<div class="text-center  m-5 flex align-items-center justify-content-center" *ngIf="loading" [style.height.px]="loaderContainerHeight">
    <div class="small-loader-wrapper">
        <div class="small-loader"></div>
      </div>
</div>
